import { render } from "./ServiciosIndex.vue?vue&type=template&id=6819215b&scoped=true"
import script from "./ServiciosIndex.vue?vue&type=script&lang=js"
export * from "./ServiciosIndex.vue?vue&type=script&lang=js"

import "./ServiciosIndex.vue?vue&type=style&index=0&id=6819215b&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6819215b"]])

export default __exports__